$('.yt_video').click(function(){
	video = '<iframe allow="autoplay" loading="lazy" src="'+ $(this).attr('youtube') +'" frameborder="0"></iframe>';
	$(this).replaceWith(video);
});
